module.exports = __webpack_public_path__ + "img/idaay-new.43e73657.jpg";